import { ToggleButtonLabelSize, YesNoToggleButton } from '@apply/components';
import { useBorrowerUsingPmc } from '../../../queries/BorrowerFields/CoreFields';
import { useBorrowerPmcName, useBorrowerPmcWebsite } from '../../../queries/BorrowerFields/PmcFields';
import { ApplicationQuestionReviewItem } from '../../components/ApplicationQuestionReviewItem';
import { ButtonGroupTypes } from 'devextreme-react/button-group';

interface PropertyManagementProps {
    required?: boolean;
    isReview?: boolean;
}

export const PropertyManagement: React.FC<PropertyManagementProps> = ({ required = false, isReview = false }) => {
    const label = 'Will you use a property management company?';
    const [willUsePropertyManagement, set_willUsePropertyManagement] = useBorrowerUsingPmc();
    const [, set_propertyManagementCompanyName] = useBorrowerPmcName();
    const [, set_propertyManagementCompanyWebsite] = useBorrowerPmcWebsite();

    const toggleButtonYesNoClick = (e: ButtonGroupTypes.ItemClickEvent) => {
        switch (e.itemData?.id.toLowerCase()) {
            case 'yes':
                set_willUsePropertyManagement(true);
                return;
            case 'no':
                set_willUsePropertyManagement(false);
                set_propertyManagementCompanyName('');
                set_propertyManagementCompanyWebsite('');
                return;
            default:
                return;
        }
    };

    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={willUsePropertyManagement ? 'Yes' : 'No'}
                />
            ) : (
                <>
                    <YesNoToggleButton
                        id='toggleButtonPropertyManagement'
                        value={willUsePropertyManagement}
                        onItemClick={toggleButtonYesNoClick}
                        width='230px'
                        height='40px'
                        required={required}
                        requiredMessage='Property Management required'
                        label={label}
                        labelSize={ToggleButtonLabelSize.Medium}
                    />
                </>
            )}
        </>
    );
};
